
import { fillSeo } from 'razlet-sulu-sdk/lib/utils/helpers';
import { capitalize } from '~/utils';

export default {
  name: 'schedule-head',
  model: {
    prop: 'request',
    event: 'change',
  },
  props: {
    request: {
      type: Object,
      required: true,
    },
    loading: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    isFirstPage () {
      return this.$route.name === 'passazhiram-schedule';
    },
    backPath() {
      return this.$nuxt?.context?.from?.path ? this.$nuxt.context.from.path : '';
    },
    title() {
      let title = `${this.$t('schedule.title')}`;
      if (!this.loading && this.request.from && this.request.from.code) title += ` ${capitalize(this.request.from.name)}`;
      if (!this.loading && this.request.to && this.request.to.code) title += ` — ${capitalize(this.request.to.name)}`;
      return title;
    },
    description() {
      let title = `${this.$t('schedule.description')[0]}`;
      if (!this.loading && this.request.from && this.request.from.code) title += ` ${capitalize(this.request.from.name)}`;
      if (!this.loading && this.request.to && this.request.to.code) title += ` — ${capitalize(this.request.to.name)}`;
      title += `${this.$t('schedule.description')[1]}`;
      return title;
    },
  },
  head(Vue) {
    return this.isFirstPage ? null : fillSeo(Vue, this);
  },
};
